module.exports = __webpack_public_path__ + "img/学术会议-6.b85b674a.jpg";